import Vue from 'vue';

function initialState() {
  return {
    UserRoles: [],
    DealSheetCollectionPagination: {},
    CustomersSuperset: [],
    LeadCollectionPagination: {},
    LeadsSuperset: [],
    LeadsReassignments: [],
    ProcessSuperset: [],
    ProcessCollectionPagination: {},
    CustomersReassignments: [],
    GroupsReassignments: [],
    ProcessReassignments: [],
    MigrationResponse: {},
    CustomersRecordDisplayCount: 0,
    LeadsRecordDisplayCount: 0,
    GroupsRecordDisplayCount: 0,
    ProcessRecordDisplayCount: 0,
    ReassignmentUsers: [],
    DeactivatedUserInfo: {},
    DeactivatedUsersAdminGroups: [],
    DeactivatedUserAlertMinerId: 0,
    TasksRecordDisplayCount: 0,
    SyncFixResponse: {},
    UserDeactivationSwitch: {}
  };
}

const state = initialState();

const actions = {

  getUserRoles: function(context, param) {
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.get('/rolepermissions/getrolesforuser/' + param.userId).then(function (data) {
        let roles = data.data.Data;
        context.commit("loadUserRoles", roles);
        resolve(roles);
      }).catch((error) => reject(error));
    });
  },
  clearUserRoles: function(context) {
    context.commit("clearUserRoles", []);
  },
  getUserOwnedDealSheets: function(context, param) {
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.post('/userdeactivation/getuserowneddealsheets',param).then(function (data) {
        let userOwnedDealSheets = data.data.Data.CustomerDealSheets;
        userOwnedDealSheets.forEach(element => element.IsChecked = false);
        let userOwnedDealSheetPagination = data.data.Data.PaginationResponse;
        context.commit("updateUserOwnedDealSheetPagination", userOwnedDealSheetPagination);
        resolve(data.data.Data);
      }).catch((error) => reject(error));
    });
  },
  getUserOwnedLeads: function(context, param) {
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.post('/userdeactivation/getuserownedleads',param).then(function (data) {
        let contactLeads = data.data.Data.ContactLeads;
        contactLeads.forEach(element => element.IsChecked = false);
        let contactLeadPagination = data.data.Data.PaginationResponse;
        context.commit("updateLeadCollectionPagination", contactLeadPagination);
        resolve(data.data.Data);
      }).catch((error) => reject(error));
    });
  },
  getRelevantUserDeactivationGroups: function(context, param){
    let vm = this;

    return new Promise((resolve, reject) => {
      Vue.http.get('/core/groups/relevantuserdeactivationgroups?userId=' + param).then(function (data) {
        let usersAdminGroups =  data.data.Data;
        context.commit("updateDeactivatedUsersAdminGroup", usersAdminGroups);
        resolve(usersAdminGroups);
      }).catch((error) => reject(error));
    });
  },
  getGroup: function(context, groupId){
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.get('/core/groups/' + groupId).then(function (data) {
        let group = data.data.Data;
        resolve(group);
      }).catch((error) => reject(error));
    });
  },
  getUserDeactivationSwitch: function(context){
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.get('/userdeactivation/userdeactivationswitch').then(function (response) {
        if(response && response.data.Data){
          let switches = response.data.Data;
          context.commit("loadUserDeactivationSwitch", switches);
          resolve(switches);
        } else {
          reject(response);
        }
      }).catch((error) => reject(error));
    });
  },
  getProcesses: function(context, param){
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.post('/userdeactivation/getUserOwnedProcesses', param).then(function (data) {
        let response = data.data.Data;
        let updatedProcesses = [];
        response.Processes.forEach(process => {
          let updatedProcess = JSON.parse(JSON.stringify(process));
          updatedProcess.AssignedAs = process.AssignedAs.charAt(0).toUpperCase() + process.AssignedAs.slice(1);
          updatedProcess.LogicalId = process.Id + '_' + process.AssignedAs;
          updatedProcesses.push(updatedProcess);
        });
        context.commit("loadProcessSuperset", updatedProcesses);
        context.dispatch("updateProcessRecordDisplayCount", response.TotalRecords, {root:true});
        context.dispatch("updateProcessCollectionPagination", response.PaginationResponse, {root:true});
        resolve(response);
      }).catch((error) => reject(error));
    });
  },
  loadCustomersSuperset: function(context, data){
    context.commit("loadCustomersSuperset", data);
  },
  loadCustomersReassignments: function(context, data){
    context.commit("loadCustomersReassignments", data);
    context.dispatch("updateLeadDependenciesFromCustomerReassignments", data, { root: true });
  },
  loadLeadsSuperset: function(context, data){
    context.commit("loadLeadsSuperset", data);
  },
  loadLeadsReassignments: function(context, data){
    context.commit("loadLeadsReassignments", data);
    context.dispatch("updateCustomerDependenciesFromLeadReassignments", data, { root: true });
  },
  loadProcessReassignments: function(context, data){
    context.commit("loadProcessReassignments", data);
  },
  loadGroupsReassignments: function(context, data){
    context.commit("loadGroupsReassignments", data);
  },
  loadProcessSuperset: function(context, data){
    context.commit("loadProcessSuperset", data);
  },
  updateProcessCollectionPagination: function(context, data){
    context.commit("updateProcessCollectionPagination", data);
  },
  saveMigrationRequest: function(context,param){
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.post("/userdeactivation/saveUserMigrationRequest", param).then(function (data) {
        let response = data.data.Data;
        context.commit("loadMigrationResponse", response);
        resolve(response);
      }).catch((error) => reject(error));
    });
  },
  clearViewModel: function(context) {
    context.commit("clearViewModel");
  },
  updateLeadDependenciesFromCustomerReassignments: function(context, data){
    let leadReassignmentsFromCustomers = [];
    let customerReassignments = JSON.parse(JSON.stringify(data));
    let leadReassignments = (this.getters.LeadsReassignments.length === 0) ? [] : JSON.parse(JSON.stringify(this.getters.LeadsReassignments));
    let customerSuperSet = (this.getters.CustomersSuperset.length === 0) ? [] :  JSON.parse(JSON.stringify(this.getters.CustomersSuperset));
    let leadSuperSet = (this.getters.LeadsSuperset.length === 0) ? [] :  JSON.parse(JSON.stringify(this.getters.LeadsSuperset));
    let leadContactsRelatedToCustomers = leadSuperSet.filter(lead => customerReassignments.map(customer => customer.ContactId).indexOf(lead.ContactId) > -1);
    leadContactsRelatedToCustomers.forEach(lead => {
      let customerReassignment = customerReassignments.filter(customer => customer.ContactId === lead.ContactId)[0];
      leadReassignmentsFromCustomers.push(customerReassignment);
    });
    let reassignedContacts = leadContactsRelatedToCustomers.map(customer => customer.ContactId);
    leadReassignments.forEach(leadReassignment => {
      let index = reassignedContacts.indexOf(leadReassignment.ContactId);
      if(index === -1){
        let customerReassignment = customerReassignments.filter(assign => assign.ContactId === leadReassignment.ContactId)[0];
        let isCustomerInSuperset = customerSuperSet.filter(assign => assign.ContactId === leadReassignment.ContactId)[0];
        if(!customerReassignment && !isCustomerInSuperset){
          leadReassignmentsFromCustomers.push(leadReassignment);
        }
      }
    });

    context.commit("loadLeadsReassignments", leadReassignmentsFromCustomers);
  },
  updateCustomerDependenciesFromLeadReassignments: function(context, data){
    let customerReassignmentsFromLeads = [];
    let leadReassignments = JSON.parse(JSON.stringify(data));
    let customerReassignments = (this.getters.CustomersReassignments.length === 0) ? [] : JSON.parse(JSON.stringify(this.getters.CustomersReassignments));
    let customerSuperSet = (this.getters.CustomersSuperset.length === 0) ? [] :  JSON.parse(JSON.stringify(this.getters.CustomersSuperset));
    let leadSuperSet = (this.getters.LeadsSuperset.length === 0) ? [] :  JSON.parse(JSON.stringify(this.getters.LeadsSuperset));
    let customerContactsRelatedToLeads = customerSuperSet.filter(customer => leadReassignments.map(lead => lead.ContactId).indexOf(customer.ContactId) > -1);

    customerContactsRelatedToLeads.forEach(customer => {
      let customerReassignment = leadReassignments.filter(lead => lead.ContactId === customer.ContactId)[0];
      customerReassignmentsFromLeads.push(customerReassignment);
    });

    let reassignedContacts = customerContactsRelatedToLeads.map(customer => customer.ContactId);
    customerReassignments.forEach(customerReassignment => {
      let index = reassignedContacts.indexOf(customerReassignment.ContactId);
      if(index === -1){
        let leadAssignment = leadReassignments.filter(assign => assign.ContactId === customerReassignment.ContactId)[0];
        let isLeadInSuperset = leadSuperSet.filter(assign => assign.ContactId === customerReassignment.ContactId)[0];
        if(!leadAssignment && !isLeadInSuperset){
          customerReassignmentsFromLeads.push(customerReassignment);
        }
      }
    });

    context.commit("loadCustomersReassignments", customerReassignmentsFromLeads);
  },
  updateCustomersRecordDisplayCount: function(context, data){
    context.commit("updateCustomersRecordDisplayCount", data);
  },
  updateLeadsRecordDisplayCount: function(context, data){
    context.commit("updateLeadsRecordDisplayCount", data);
  },
  updateGroupsRecordDisplayCount: function(context, data){
    context.commit("updateGroupsRecordDisplayCount", data);
  },
  getReassignmentUsers: function (context,data){
    let vm = this;
    let queryArgs = [];
    data.forEach(platformId => queryArgs.push("platformIds=" + platformId));
    let query = queryArgs.join("&");
    return new Promise((resolve, reject) => {
      Vue.http.get('/users/commonusers?' + query).then(function (data) {
        let users = data.data.Data;
        context.commit("updateReassignmentUsers", users);
        resolve(users);
      }).catch((error) => reject(error));
    });
  },
  updateReassignmentUsers: function (context, data){
    context.commit("updateReassignmentUsers", data);
  },
  loadDeactivatedUser: function(context, data){
    context.commit("loadDeactivatedUser", data);
  },
  updateDeactivatedUsersAdminGroup: function(context, data){
    context.commit("updateDeactivatedUsersAdminGroup", data);
  },
  loadDeactivatedUserAlertMinerId: function(context, data){
    context.commit("loadDeactivatedUserAlertMinerId", data);
  },
  updateProcessRecordDisplayCount: function(context, data){
    context.commit("updateProcessRecordDisplayCount", data);
  },
  loadUserOwnedTaskCount: function(context,param){
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.post("/userdeactivation/getuserownedtaskscount", param).then(function (data) {
        let userOwnedTaskCount = data.data.Data;
        context.commit("loadUserOwnedTaskCount", userOwnedTaskCount);
        resolve(userOwnedTaskCount);
      }).catch((error) => reject(error));
    });
  },
  syncFix: function(context,param){
    let vm = this;
    return new Promise((resolve, reject) => {
      Vue.http.post("/core/userintegrity/fix", param).then(function (data) {
        let syncFixResponse = data.data.Data;
        context.commit("loadSyncFixResponse", syncFixResponse);
        resolve(syncFixResponse);
      }).catch((error) => reject(error));
    });
  },
  loadUserDeactivationSwitch: function (context, data){
    context.commit("loadUserDeactivationSwitch", data);
  }
};

const mutations = {
  loadUserRoles: function (state, data) {
    state.UserRoles = data;
  },
  clearUserRoles: function (state, data) {
    state.UserRoles = data;
  },
  updateUserOwnedDealSheetPagination: function(state, data){
    state.DealSheetCollectionPagination = data;
  },
  updateLeadCollectionPagination: function(state, data){
    state.LeadCollectionPagination = data;
  },
  updateProcessCollectionPagination: function(state, data){
    state.ProcessCollectionPagination = data;
  },
  loadCustomersSuperset: function(state, data){
    state.CustomersSuperset = data;
  },
  loadCustomersReassignments: function(state, data){
    state.CustomersReassignments = data;
  },
  loadLeadsSuperset: function(state, data){
    state.LeadsSuperset = data;
  },
  loadLeadsReassignments: function(state, leadReassignments){
    state.LeadsReassignments = leadReassignments;
  },
  loadGroupsReassignments: function(state, groupReassignments){
    state.GroupsReassignments = groupReassignments;
  },
  loadProcessReassignments: function(state, data){
    state.ProcessReassignments = data;
  },
  loadMigrationResponse: function(state, data){
    state.MigrationResponse = data;
  },
  clearViewModel: function(state){
    state.UserRoles = [];
    state.DealSheetCollectionPagination = {};
    state.CustomersSuperset = [];
    state.LeadCollectionPagination = {};
    state.LeadsSuperset = [];
    state.LeadsReassignments = [];
    state.CustomersReassignments = [];
    state.MigrationResponse = {};
    state.CustomersRecordDisplayCount = 0;
    state.LeadsRecordDisplayCount = 0;
    state.ReassignmentUsers = [];
    state.DeactivatedUserInfo = {};
    state.DeactivatedUsersAdminGroups = [];
    state.DeactivatedUserAlertMinerId = 0;
    state.GroupsRecordDisplayCount = 0;
    state.TasksRecordDisplayCount = 0;
    state.SyncFixResponse = {};
    state.ProcessSuperset = [];
    state.ProcessRecordDisplayCount = 0;
    state.ProcessCollectionPagination = {};
  },
  updateCustomersRecordDisplayCount: function(state, data){
    state.CustomersRecordDisplayCount = data;
  },
  updateLeadsRecordDisplayCount: function(state, data){
    state.LeadsRecordDisplayCount = data;
  },
  updateGroupsRecordDisplayCount: function(state, data){
    state.GroupsRecordDisplayCount = data;
  },
  updateProcessRecordDisplayCount: function(state, data){
    state.ProcessRecordDisplayCount = data;
  },
  updateReassignmentUsers: function(state, data){
    state.ReassignmentUsers = data;
  },
  loadDeactivatedUser: function(state, data){
    state.DeactivatedUserInfo = data;
  },
  updateDeactivatedUsersAdminGroup: function(state, data){
    state.DeactivatedUsersAdminGroups = data;
  },
  loadDeactivatedUserAlertMinerId: function(state, data){
    state.DeactivatedUserAlertMinerId = data;
  },
  loadUserOwnedTaskCount: function(state, data){
    state.TasksRecordDisplayCount = data;
  },
  loadSyncFixResponse: function(state, data){
    state.SyncFixResponse = data;
  },
  loadProcessSuperset: function(state, data){
    state.ProcessSuperset = data;
  },
  loadUserDeactivationSwitch: function(state, data){
    state.UserDeactivationSwitch = data;
  }
};

const getters = {
  UserRoles: function () {
    return state.UserRoles;
  },
  DealSheetCollectionPagination: function () {
    return state.DealSheetCollectionPagination;
  },
  LeadCollectionPagination: function(){
    return state.LeadCollectionPagination;
  },
  LeadsSuperset: function(){
    return state.LeadsSuperset;
  },
  LeadsReassignments: function(){
    return state.LeadsReassignments;
  },
  MigrationResponse: function(){
    return state.MigrationResponse;
  },
  CustomersSuperset: function(){
    return state.CustomersSuperset;
  },
  CustomersReassignments: function(){
    return state.CustomersReassignments;
  },
  CustomersRecordDisplayCount: function(){
    return state.CustomersRecordDisplayCount;
  },
  LeadsRecordDisplayCount: function(){
    return state.LeadsRecordDisplayCount;
  },
  GroupsRecordDisplayCount: function(){
    return state.GroupsRecordDisplayCount;
  },
  ReassignmentUsers: function(){
    return state.ReassignmentUsers;
  },
  DeactivatedUserInfo: function(){
    return state.DeactivatedUserInfo;
  },
  GroupsReassignments: function(){
    return state.GroupsReassignments;
  },
  DeactivatedUsersAdminGroups: function(){
    return state.DeactivatedUsersAdminGroups;
  },
  DeactivatedUserAlertMinerId: function(){
    return state.DeactivatedUserAlertMinerId;
  },
  TasksRecordDisplayCount: function(){
    return state.TasksRecordDisplayCount;
  },
  SyncFixResponse: function(){
    return state.SyncFixResponse;
  },
  ProcessSuperset: function(){
    return state.ProcessSuperset
  },
  ProcessCollectionPagination: function(){
    return state.ProcessCollectionPagination;
  },
  ProcessRecordDisplayCount: function(){
    return state.ProcessRecordDisplayCount;
  },
  UserDeactivationSwitch: function(){
    return state.UserDeactivationSwitch;
  }
};


export default {
  state,
  actions,
  mutations,
  getters
}




// WEBPACK FOOTER //
// ./src/store/modules/users/UserDeactivation.js